import React, { ButtonHTMLAttributes } from 'react';
import { FaSearch } from 'react-icons/fa';

import { Container } from './styles';

type ISearchProps = ButtonHTMLAttributes<HTMLButtonElement>;

const Search: React.FC<ISearchProps> = ({ ...rest }) => {
  return (
    <Container {...rest} type="button">
      Pesquisar <FaSearch size={20} />
    </Container>
  );
};

export default Search;
